import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTES_PATH } from '@/shared/constants/routes';
import { Button } from '@/shared/ui/lib/Button';
import { CustomTypography } from '@/shared/ui/Typography';

import { StyledBox, StyledIconWrap, StyledOops, StyledText } from './styles';

export const PaymentSuccessPage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBackToChannels = () => {
    navigate(`/${ROUTES_PATH.MAIN.CHANNELS}`);
  };

  return (
    <StyledBox>
      <StyledText>
        <StyledIconWrap>
          <CheckCircleOutlineIcon />
        </StyledIconWrap>
        <StyledOops>{t('billing:paymentSuccessPage.title')}</StyledOops>
        <CustomTypography sx={{ fontSize: '18px' }}>
          {t('billing:paymentSuccessPage.description')}
        </CustomTypography>

        <div>
          <Button
            color="primary"
            variant="contained"
            size="medium"
            onClick={handleBackToChannels}
          >
            {t('billing:paymentSuccessPage.backToChannels')}
          </Button>
        </div>
      </StyledText>
    </StyledBox>
  );
};
